import {
  TOGGLE_EMPLOYEE_MODAL,
  GET_BASIC_INFO,
  GET_BASIC_INFO_SUCCESS,
  GET_BASIC_INFO_FAILURE,
  UPDATE_BASIC_INFO,
  UPDATE_BASIC_INFO_SUCCESS,
  UPDATE_BASIC_INFO_FAILURE,
  GET_EMPLOYEEMENT_INFO,
  GET_EMPLOYEEMENT_INFO_SUCCESS,
  GET_EMPLOYEEMENT_INFO_FAILURE,
  UPDATE_EMPLOYEEMENT_INFO,
  UPDATE_EMPLOYEEMENT_INFO_SUCCESS,
  UPDATE_EMPLOYEEMENT_INFO_FAILURE,
  GET_PERMISSIONS,
  GET_PERMISSIONS_SUCCESS,
  GET_PERMISSIONS_FAILURE,
  UPDATE_PERMISSIONS,
  UPDATE_PERMISSIONS_SUCCESS,
  UPDATE_PERMISSIONS_FAILURE,
  GET_LINE_INFO,
  GET_LINE_INFO_SUCCESS,
  GET_LINE_INFO_FAILURE,
  UPDATE_LINE_INFO,
  UPDATE_LINE_INFO_SUCCESS,
  UPDATE_LINE_INFO_FAILURE,
  GET_WORKING_INFO,
  GET_WORKING_INFO_SUCCESS,
  GET_WORKING_INFO_FAILURE,
  UPDATE_WORKING_INFO,
  UPDATE_WORKING_INFO_SUCCESS,
  UPDATE_WORKING_INFO_FAILURE,
  GET_ROLE_INFO,
  GET_ROLE_INFO_SUCCESS,
  GET_ROLE_INFO_FAILURE,
  UPDATE_ROLE_INFO,
  UPDATE_ROLE_INFO_SUCCESS,
  UPDATE_ROLE_INFO_FAILURE,
  GET_WORKING_LOCATIONS,
  GET_WORKING_LOCATIONS_SUCCESS,
  GET_WORKING_LOCATIONS_FAILURE,
  UPDATE_LOCATIONS,
  UPDATE_LOCATIONS_SUCCESS,
  UPDATE_LOCATIONS_FAILURE,
  GET_ONBOARDING_STEPS,
  GET_ONBOARDING_STEPS_SUCCESS,
  GET_ONBOARDING_STEPS_FAILURE,
  GET_STEP_DETAILS,
  GET_STEP_DETAILS_SUCCESS,
  GET_STEP_DETAILS_FAILURE,
  SET_FIELDS,
  TOGGLE_APPROVE_MODAL,
  TOGGLE_STEP_APPROVE_MODAL,
  APPROVE_FIELD,
  APPROVE_FIELD_SUCCESS,
  APPROVE_FIELD_FAILURE,
  GET_PERSONAL_INFO,
  GET_PERSONAL_INFO_SUCCESS,
  GET_PERSONAL_INFO_FAILURE,
  UPDATE_PERSONAL_INFO,
  UPDATE_PERSONAL_INFO_SUCCESS,
  UPDATE_PERSONAL_INFO_FAILURE,
  GET_DOCUMENTS,
  GET_DOCUMENTS_SUCCESS,
  GET_DOCUMENTS_FAILURE,
  GET_HOLIDAY_INFO,
  GET_HOLIDAY_INFO_SUCCESS,
  GET_HOLIDAY_INFO_FAILURE,
  GET_LEAVES,
  GET_LEAVES_SUCCESS,
  GET_LEAVES_FAILURE,
  UPDATE_HOLIDAY_INFO,
  UPDATE_HOLIDAY_INFO_SUCCESS,
  UPDATE_HOLIDAY_INFO_FAILURE,
  GET_PAYROLL_INFO,
  GET_PAYROLL_INFO_SUCCESS,
  GET_PAYROLL_INFO_FAILURE,
  UPDATE_PAYROLL_INFO,
  UPDATE_PAYROLL_INFO_SUCCESS,
  UPDATE_PAYROLL_INFO_FAILURE,
  TOGGLE_STEP_FILE_MODAL,
  TOGGLE_VIEW_FILE_MODAL,
  DOWNLOAD_FILE,
  DOWNLOAD_FILE_SUCCESS,
  DOWNLOAD_FILE_FAILURE,
  DELETE_FILE,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAILURE,
  GET_VERSION_HISTORY,
  GET_VERSION_HISTORY_SUCCESS,
  GET_VERSION_HISTORY_FAILURE,
  SEND_REVISION_MAIL,
  SEND_REVISION_MAIL_SUCCESS,
  SEND_REVISION_MAIL_FAILURE,
  GET_DOC_VERSIONS,
  GET_DOC_VERSIONS_SUCCESS,
  GET_DOC_VERSIONS_FAILURE,
  SEND_DOC_MAIL,
  SEND_DOC_MAIL_SUCCESS,
  SEND_DOC_MAIL_FAILURE,
  GET_DOC_CORRECTIONS,
  GET_DOC_CORRECTIONS_SUCCESS,
  GET_DOC_CORRECTIONS_FAILURE,
  UPLOAD_NEW_DOC,
  UPLOAD_NEW_DOC_SUCCESS,
  UPLOAD_NEW_DOC_FAILURE,
  GET_STEP_HISTORY,
  GET_STEP_HISTORY_SUCCESS,
  GET_STEP_HISTORY_FAILURE,
  TOGGLE_STEP_HISTORY_MODAL,
  SET_STEP_TITLE,
  UPDATE_ONBOARDING_DATA,
  GET_ADDITIONAL_DOCUMENTS,
  GET_ADDITIONAL_DOCUMENTS_SUCCESS,
  GET_ADDITIONAL_DOCUMENTS_FAILURE,
  TOGGLE_ADDITIONAL_DOCUMENT_MODAL,
  GET_DOCS_HISTORY,
  GET_DOCS_HISTORY_SUCCESS,
  GET_DOCS_HISTORY_FAILURE,
  EDIT_VERSION_FILE,
  EDIT_VERSION_FILE_SUCCESS,
  EDIT_VERSION_FILE_FAILURE,
} from "./constants";

export const toggleEmployeeModal = (payload) => ({
  type: TOGGLE_EMPLOYEE_MODAL,
  payload,
});

export const getBasicInfo = (payload, callback) => ({
  type: GET_BASIC_INFO,
  payload,
  callback,
});

export const getBasicInfoSuccess = (payload) => ({
  type: GET_BASIC_INFO_SUCCESS,
  payload,
});

export const getBasicInfoFailure = (payload) => ({
  type: GET_BASIC_INFO_FAILURE,
  payload,
});

export const updateBasicInfo = (payload, callback) => ({
  type: UPDATE_BASIC_INFO,
  payload,
  callback,
});

export const updateBasicInfoSuccess = (payload) => ({
  type: UPDATE_BASIC_INFO_SUCCESS,
  payload,
});

export const updateBasicInfoFailure = (payload) => ({
  type: UPDATE_BASIC_INFO_FAILURE,
  payload,
});

export const getEmploymentInfo = (payload) => ({
  type: GET_EMPLOYEEMENT_INFO,
  payload,
});

export const getEmploymentInfoSuccess = (payload) => ({
  type: GET_EMPLOYEEMENT_INFO_SUCCESS,
  payload,
});

export const getEmploymentInfoFailure = (payload) => ({
  type: GET_EMPLOYEEMENT_INFO_FAILURE,
  payload,
});

export const updateEmploymentInfo = (payload, callback) => ({
  type: UPDATE_EMPLOYEEMENT_INFO,
  payload,
  callback,
});

export const updateEmploymentInfoSuccess = (payload) => ({
  type: UPDATE_EMPLOYEEMENT_INFO_SUCCESS,
  payload,
});

export const updateEmploymentInfoFailure = (payload) => ({
  type: UPDATE_EMPLOYEEMENT_INFO_FAILURE,
  payload,
});

export const getPermissions = (payload) => ({
  type: GET_PERMISSIONS,
  payload,
});

export const getPermissionsSuccess = (payload) => ({
  type: GET_PERMISSIONS_SUCCESS,
  payload,
});

export const getPermissionsFailure = (payload) => ({
  type: GET_PERMISSIONS_FAILURE,
  payload,
});

export const updatePermissions = (payload, callback) => ({
  type: UPDATE_PERMISSIONS,
  payload,
  callback,
});

export const updatePermissionsSuccess = (payload) => ({
  type: UPDATE_PERMISSIONS_SUCCESS,
  payload,
});

export const updatePermissionsFailure = (payload) => ({
  type: UPDATE_PERMISSIONS_FAILURE,
  payload,
});

export const getLineInfo = (payload) => ({
  type: GET_LINE_INFO,
  payload,
});

export const getLineInfoSuccess = (payload) => ({
  type: GET_LINE_INFO_SUCCESS,
  payload,
});

export const getLineInfoFailure = (payload) => ({
  type: GET_LINE_INFO_FAILURE,
  payload,
});

export const updateLineInfo = (payload, callback) => ({
  type: UPDATE_LINE_INFO,
  payload,
  callback,
});

export const updateLineInfoSuccess = (payload) => ({
  type: UPDATE_LINE_INFO_SUCCESS,
  payload,
});

export const updateLineInfoFailure = (payload) => ({
  type: UPDATE_LINE_INFO_FAILURE,
  payload,
});

export const getWorkingInfo = (payload) => ({
  type: GET_WORKING_INFO,
  payload,
});

export const getWorkingInfoSuccess = (payload) => ({
  type: GET_WORKING_INFO_SUCCESS,
  payload,
});

export const getWorkingInfoFailure = (payload) => ({
  type: GET_WORKING_INFO_FAILURE,
  payload,
});

export const updateWorkingInfo = (payload, callback) => ({
  type: UPDATE_WORKING_INFO,
  payload,
  callback,
});

export const updateWorkingInfoSuccess = (payload) => ({
  type: UPDATE_WORKING_INFO_SUCCESS,
  payload,
});

export const updateWorkingInfoFailure = (payload) => ({
  type: UPDATE_WORKING_INFO_FAILURE,
  payload,
});

export const getRoleInfo = (payload, callback) => ({
  type: GET_ROLE_INFO,
  payload,
  callback,
});

export const getRoleInfoSuccess = (payload) => ({
  type: GET_ROLE_INFO_SUCCESS,
  payload,
});

export const getRoleInfoFailure = (payload) => ({
  type: GET_ROLE_INFO_FAILURE,
  payload,
});

export const updateRoleInfo = (payload, callback) => ({
  type: UPDATE_ROLE_INFO,
  payload,
  callback,
});

export const updateRoleInfoSuccess = (payload) => ({
  type: UPDATE_ROLE_INFO_SUCCESS,
  payload,
});

export const updateRoleInfoFailure = (payload) => ({
  type: UPDATE_ROLE_INFO_FAILURE,
  payload,
});

export const getWorkingLocations = (payload, callback) => ({
  type: GET_WORKING_LOCATIONS,
  payload,
  callback,
});

export const getWorkingLocationsSuccess = (payload) => ({
  type: GET_WORKING_LOCATIONS_SUCCESS,
  payload,
});

export const getWorkingLocationsFailure = (payload) => ({
  type: GET_WORKING_LOCATIONS_FAILURE,
  payload,
});

export const updateLocations = (payload, callback) => ({
  type: UPDATE_LOCATIONS,
  payload,
  callback,
});

export const updateLocationsSuccess = (payload) => ({
  type: UPDATE_LOCATIONS_SUCCESS,
  payload,
});

export const updateLocationsFailure = (payload) => ({
  type: UPDATE_LOCATIONS_FAILURE,
  payload,
});

export const getOnboardingSteps = (payload, onGet) => ({
  type: GET_ONBOARDING_STEPS,
  payload,
  onGet,
});

export const getOnboardingStepsSuccess = (payload) => ({
  type: GET_ONBOARDING_STEPS_SUCCESS,
  payload,
});

export const getOnboardingStepsFailure = (payload) => ({
  type: GET_ONBOARDING_STEPS_FAILURE,
  payload,
});

export const getStepDetails = (payload, callback) => ({
  type: GET_STEP_DETAILS,
  payload,
  callback,
});

export const getStepDetailsSuccess = (payload) => ({
  type: GET_STEP_DETAILS_SUCCESS,
  payload,
});

export const getStepDetailsFailure = (payload) => ({
  type: GET_STEP_DETAILS_FAILURE,
  payload,
});

export const setFields = (payload) => ({
  type: SET_FIELDS,
  payload,
});

export const toggleApproveModal = (payload) => ({
  type: TOGGLE_APPROVE_MODAL,
  payload,
});

export const toggleStepApproveModal = (payload) => ({
  type: TOGGLE_STEP_APPROVE_MODAL,
  payload,
});

export const approveField = (payload, callback) => ({
  type: APPROVE_FIELD,
  payload,
  callback,
});

export const approveFieldSuccess = (payload) => ({
  type: APPROVE_FIELD_SUCCESS,
  payload,
});

export const approveFieldFailure = (payload) => ({
  type: APPROVE_FIELD_FAILURE,
  payload,
});

export const getPersonalInfo = (payload) => ({
  type: GET_PERSONAL_INFO,
  payload,
});

export const getPersonalInfoSuccess = (payload) => ({
  type: GET_PERSONAL_INFO_SUCCESS,
  payload,
});

export const getPersonalInfoFailure = (payload) => ({
  type: GET_PERSONAL_INFO_FAILURE,
  payload,
});

export const updatePersonalInfo = (payload, callback) => ({
  type: UPDATE_PERSONAL_INFO,
  payload,
  callback,
});

export const updatePersonalInfoSuccess = (payload) => ({
  type: UPDATE_PERSONAL_INFO_SUCCESS,
  payload,
});

export const updatePersonalInfoFailure = (payload) => ({
  type: UPDATE_PERSONAL_INFO_FAILURE,
  payload,
});

export const getDocuments = (payload) => ({
  type: GET_DOCUMENTS,
  payload,
});
export const getDocumentsSuccess = (payload) => ({
  type: GET_DOCUMENTS_SUCCESS,
  payload,
});
export const getDocumentsFailure = (payload) => ({
  type: GET_DOCUMENTS_FAILURE,
  payload,
});

export const getHolidayInfo = (payload) => ({
  type: GET_HOLIDAY_INFO,
  payload,
});
export const getHolidayInfoSuccess = (payload) => ({
  type: GET_HOLIDAY_INFO_SUCCESS,
  payload,
});
export const getHolidayInfoFailure = (payload) => ({
  type: GET_HOLIDAY_INFO_FAILURE,
  payload,
});

export const getLeaves = (payload) => ({
  type: GET_LEAVES,
  payload,
});
export const getLeavesSuccess = (payload) => ({
  type: GET_LEAVES_SUCCESS,
  payload,
});
export const getLeavesFailure = (payload) => ({
  type: GET_LEAVES_FAILURE,
  payload,
});

export const updateHolidayInfo = (payload, callback) => ({
  type: UPDATE_HOLIDAY_INFO,
  payload,
  callback,
});

export const updateHolidayInfoSuccess = (payload) => ({
  type: UPDATE_HOLIDAY_INFO_SUCCESS,
  payload,
});

export const updateHolidayInfoFailure = (payload) => ({
  type: UPDATE_HOLIDAY_INFO_FAILURE,
  payload,
});

export const getPayrollInfo = (payload) => ({
  type: GET_PAYROLL_INFO,
  payload,
});
export const getPayrollInfoSuccess = (payload) => ({
  type: GET_PAYROLL_INFO_SUCCESS,
  payload,
});
export const getPayrollInfoFailure = (payload) => ({
  type: GET_PAYROLL_INFO_FAILURE,
  payload,
});

export const updatePayrollInfo = (payload, callback) => ({
  type: UPDATE_PAYROLL_INFO,
  payload,
  callback,
});
export const updatePayrollInfoSuccess = (payload) => ({
  type: UPDATE_PAYROLL_INFO_SUCCESS,
  payload,
});
export const updatePayrollInfoFailure = (payload) => ({
  type: UPDATE_PAYROLL_INFO_FAILURE,
  payload,
});

export const toggleStepFileModal = (payload) => ({
  type: TOGGLE_STEP_FILE_MODAL,
  payload,
});

export const toggleViewFileModal = (payload) => ({
  type: TOGGLE_VIEW_FILE_MODAL,
  payload,
});

export const downloadFile = (payload, onSuccess) => ({
  type: DOWNLOAD_FILE,
  payload,
  onSuccess,
});

export const downloadFileSuccess = (payload) => ({
  type: DOWNLOAD_FILE_SUCCESS,
  payload,
});

export const downloadFileFailure = (payload) => ({
  type: DOWNLOAD_FILE_FAILURE,
  payload,
});

export const deleteFile = (payload, callback) => ({
  type: DELETE_FILE,
  payload,
  callback,
});

export const deleteFileSuccess = (payload) => ({
  type: DELETE_FILE_SUCCESS,
  payload,
});

export const deleteFileFailure = (payload) => ({
  type: DELETE_FILE_FAILURE,
  payload,
});

export const getVersionHistory = (payload, callback) => ({
  type: GET_VERSION_HISTORY,
  payload,
  callback,
});
export const getVersionHistorySuccess = (payload) => ({
  type: GET_VERSION_HISTORY_SUCCESS,
  payload,
});
export const getVersionHistoryFailure = (payload) => ({
  type: GET_VERSION_HISTORY_FAILURE,
  payload,
});

export const sendRevisionMail = (payload, callback) => ({
  type: SEND_REVISION_MAIL,
  payload,
  callback,
});

export const sendRevisionMailSuccess = (payload) => ({
  type: SEND_REVISION_MAIL_SUCCESS,
  payload,
});

export const sendRevisionMailFailure = (payload) => ({
  type: SEND_REVISION_MAIL_FAILURE,
  payload,
});

export const getDocVersions = (payload, callback) => ({
  type: GET_DOC_VERSIONS,
  payload,
  callback,
});
export const getDocVersionsSuccess = (payload) => ({
  type: GET_DOC_VERSIONS_SUCCESS,
  payload,
});
export const getDocVersionsFailure = (payload) => ({
  type: GET_DOC_VERSIONS_FAILURE,
  payload,
});

export const sendDocMail = (payload, callback) => ({
  type: SEND_DOC_MAIL,
  payload,
  callback,
});

export const sendDocMailSuccess = (payload) => ({
  type: SEND_DOC_MAIL_SUCCESS,
  payload,
});

export const sendDocMailFailure = (payload) => ({
  type: SEND_DOC_MAIL_FAILURE,
  payload,
});

export const getDocCorrections = (payload, callback) => ({
  type: GET_DOC_CORRECTIONS,
  payload,
  callback,
});

export const getDocCorrectionsSuccess = (payload) => ({
  type: GET_DOC_CORRECTIONS_SUCCESS,
  payload,
});

export const getDocCorrectionsFailure = (payload) => ({
  type: GET_DOC_CORRECTIONS_FAILURE,
  payload,
});

export const uploadNewDoc = (payload, callback) => ({
  type: UPLOAD_NEW_DOC,
  payload,
  callback,
});

export const uploadNewDocSuccess = (payload) => ({
  type: UPLOAD_NEW_DOC_SUCCESS,
  payload,
});

export const uploadNewDocFailure = (payload) => ({
  type: UPLOAD_NEW_DOC_FAILURE,
  payload,
});

export const getStepHistory = (payload, callback) => ({
  type: GET_STEP_HISTORY,
  payload,
  callback,
});

export const getStepHistorySuccess = (payload) => ({
  type: GET_STEP_HISTORY_SUCCESS,
  payload,
});

export const getStepHistoryFailure = (payload) => ({
  type: GET_STEP_HISTORY_FAILURE,
  payload,
});

export const toggleStepHistoryModal = (payload) => ({
  type: TOGGLE_STEP_HISTORY_MODAL,
  payload,
});

export const setStepTitle = (payload) => ({
  type: SET_STEP_TITLE,
  payload,
});

export const updateOnboardingData = (payload, callback) => ({
  type: UPDATE_ONBOARDING_DATA,
  payload,
  callback,
});

export const getAdditionalDocuments = (payload, callback) => ({
  type: GET_ADDITIONAL_DOCUMENTS,
  payload,
  callback,
});

export const getAdditionalDocumentsSuccess = (payload) => ({
  type: GET_ADDITIONAL_DOCUMENTS_SUCCESS,
  payload,
});

export const getAdditionalDocumentsFailure = (payload) => ({
  type: GET_ADDITIONAL_DOCUMENTS_FAILURE,
  payload,
});

export const toggleAdditionalDocumentModal = (payload) => ({
  type: TOGGLE_ADDITIONAL_DOCUMENT_MODAL,
  payload,
});

export const getDocsHistory = (payload, callback) => ({
  type: GET_DOCS_HISTORY,
  payload,
  callback,
});

export const getDocsHistorySuccess = (payload) => ({
  type: GET_DOCS_HISTORY_SUCCESS,
  payload,
});

export const getDocsHistoryFailure = (payload) => ({
  type: GET_DOCS_HISTORY_FAILURE,
  payload,
});

export const editVersionFile = (payload, callback) => ({
  type: EDIT_VERSION_FILE,
  payload,
  callback,
});

export const editVersionFileSuccess = (payload) => ({
  type: EDIT_VERSION_FILE_SUCCESS,
  payload,
});

export const editVersionFileFailure = (payload) => ({
  type: EDIT_VERSION_FILE_FAILURE,
  payload,
});
